import React from 'react'
import styles from './index.module.scss'
import classnames from 'classnames'

export function Splash() {
  const isWriteApp = /\/examform_v2/.test(window.location.pathname)
  return (
    <div className={styles.splash}>
      <div
        className={classnames(
          styles.splash_container,
          isWriteApp ? styles.write_app_img : '',
        )}
      >
        {/*<img*/}
        {/*  src={*/}
        {/*    isWriteApp*/}
        {/*      ? 'https://static-cos.lycheer.net/xupload/20220124_lihua_write_logo.png'*/}
        {/*      : 'https://static-cos.lycheer.net/xupload/20220402_logo.png'*/}
        {/*  }*/}
        {/*  alt="十方教育 logo"*/}
        {/*/>*/}
        {isWriteApp && (
          <img
            src="https://static-cos.lycheer.net/xupload/20220124_lihua_write_logo.png"
            alt="十方教育 logo"
          />
        )}
        {/*{isWriteApp ? null : <p className={styles.title}>十方教育</p>}*/}
        {isWriteApp ? null : (
          <p className={styles.index_tips}>成就技能 助力成长</p>
        )}
        {isWriteApp ? null : (
          <div className={styles.sk_wave}>
            <div className={classnames(styles.sk_rect, styles.sk_rect1)}></div>
            <div className={classnames(styles.sk_rect, styles.sk_rect2)}></div>
            <div className={classnames(styles.sk_rect, styles.sk_rect3)}></div>
            <div className={classnames(styles.sk_rect, styles.sk_rect4)}></div>
            <div className={classnames(styles.sk_rect, styles.sk_rect5)}></div>
          </div>
        )}
      </div>
    </div>
  )
}
